export default __webpack_public_path__ + "static/media/downBlackArrow.0d00d94e.svg";